import axios from 'axios'
import {
	Message
} from 'element-ui';
import store from '@/store';
// import { getToken } from '@/utils/auth'
const service = axios.create({
	// baseURL: 'http://192.168.110.143:10010/eduAppServer', //叶
	// baseURL: 'http://47.98.191.110:10010/eduAppServer',//测试新
	// baseURL:'http://116.62.36.115:10010/eduAppServer',//测试
	// baseURL:'http://121.40.112.231:10010/eduAppServer',//线上
	baseURL:process.env.VUE_APP_BASE_API,//线上
	timeout: 5000,
});
// 添加请求拦截器
service.interceptors.request.use(
	config => {
		config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token');
		// do something before request is sent

		// if (store.getters.token) {
		// let each request carry token
		// ['X-Token'] is a custom headers key
		// please modify it according to the actual situation

		// config.headers['Authorization'] = getToken()
		// config.headers['ApiToken'] = getToken()
		// }
		return config
	},
	error => {
		// do something with request error
		console.log(error) // for debug
		return Promise.reject(error)
	}
)
// 配置响应拦截器
service.interceptors.response.use(
	response => {
		const res = response.data
		// if(res.meta.errCode == 10009){
		//   store.dispatch('user/resetToken').then(() => {
		//             location.reload()
		//           })
		// }else if(res.meta.errCode == 0){
		//   return res
		// }else if(res.meta.errCode != 0){
		//   return res
		// }
		// 自己配的
		if (res.code === 401) {
			console.log('用户已失效');
			localStorage.removeItem('userInfo');
			localStorage.removeItem('token');
			store.commit('logout')
			return res
		} else if (res.code === 200) {
			return res
		} else {
			return res
		}
	},
	error => {
		console.log('err' + error) // for debug
		Message({
			message: error,
			type: 'error',
			duration: 5 * 1000
		})
		return Promise.reject(error)
	}
)
const commonReq = (url, data, method) => {
	return service({
		url,
		data,
		method
	})
}

export default commonReq;